import React from 'react';
import { BottomSheetDialog } from '@medely/web-components';
import { PostBookingInfoLegacy } from './PostBookingInfoLegacy';
import { PostBookingInfo } from './PostBookingInfo';
import { PostBookingModalProps } from './interface';
import useDevice from '@mp/hooks/useDevice.web';
import { gateNames } from '@mp/constants';
import { useGate } from '@mp/hooks';

export const PostBookingModal = ({
  onClose,
  open,
  cancelationPolicyButton,
  job,
  jobMap,
  userCoordinates,
}: PostBookingModalProps) => {
  const isDesktop = useDevice() === 'desktop';
  const showNewPostBookingInfo = useGate(gateNames.rescreening_automation);

  return (
    <BottomSheetDialog
      open={open}
      onClose={onClose}
      title="Your shift is booked"
      data-testid="post-booking-dialog"
      isDesktop={isDesktop}
      fullScreen
      sx={{ top: isDesktop ? '32px' : 0 }}
      content={
        showNewPostBookingInfo ? (
          <PostBookingInfo job={job} />
        ) : (
          <PostBookingInfoLegacy
            cancelationPolicyButton={cancelationPolicyButton}
            jobMap={jobMap}
            job={job}
            userCoordinates={userCoordinates}
          />
        )
      }
    />
  );
};
